// Constants for different requests for current reducer
export default {
  mobileRoutes: 'MOBILE_ROUTES',
};
